import React from 'react'

const aboutData = [
  {
    title: "Experienced Professionals",
    description:
      "Our team combines deep industry expertise with fresh, innovative thinking. We stay ahead of trends so you don’t have to."
  },
  {
    title: "Client-Centric Approach",
    description:
      "We listen first, then strategize. Every campaign is designed with your business goals and audience in mind."
  },
  {
    title: "Transparent Reporting",
    description:
      "With us, you receive clear, actionable insights and progress reports, ensuring you understand your marketing ROI every step of the way."
  },
  {
    title: "Agility and Adaptability",
    description:
      "Being a startup ourselves, flexibility is our strength. We quickly pivot strategies to match algorithm updates and market shifts."
  },
  {
    title: "Cutting-Edge Technology",
    description:
      "We leverage the latest tools and platforms—including Google Ads, Meta Ads, and Instagram Ads—to maximize reach and engagement."
  }
];

const AboutSection = () => {
  return (
    <div className='backdiv'>
      <h2 className='main_heading'>WHAT SETS US APART</h2>

      <div className='what_apart_grid'>
        {/* Left content */}
        <div className='about_points'>
          <ul>
            {aboutData.map((item, index) => (
              <li key={index} className="about_point_item">
                <div className="about_point_title">{item.title}</div>
                <div className="about_point_desc">{item.description}</div>
              </li>
            ))}
          </ul>
        </div>

        {/* Right image with animated border */}
        <div className="about_apartimg">
            <img
              src="/abt_img1.webp"
              alt="About Us"
              className='zweedo_img'
              loading='lazy'
            />
         
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
